<template>
  <div class="search-bar">
    <input v-model="searchQuery" @keydown.enter="search" placeholder="Поиск..." />
  </div>
</template>

<script>
import { ref, computed } from 'vue';

export default {
  name: 'SearchBar',
  props: ['items'],
  setup(props, { emit }) {
    const searchQuery = ref('');

    const performSearch = computed(() => {
      emit('search', searchQuery.value);
    }, 300);

    const search = ()=>{
      emit('search',searchQuery.value)
    }

    return {
      search,
      searchQuery,
      performSearch,
    };
  },
};
</script>

<style scoped>
.search-bar{
  margin-top: 20px;
  margin-bottom: 10px;
}

input{
  font-size: 14px;
  min-width: 250px;
  border-radius: 5px;
  border: 1px solid rgba(183, 183, 183, 1.0);
  padding: 3px;
}
</style>
